import React, { useState } from 'react';
import { addToPriorityQueue } from '../../utils/api';
import { Button } from '../ui';

/**
 * Reusable button to add any metric/issue to Priority Queue.
 * Props: title (required), description, category, priority, estimatedTime, impact, sourceData, buttonStyle ('primary'|'secondary'|'minimal'), onSuccess
 */
function AddToQueueButton({
  title,
  description = '',
  category = 'General',
  priority = 'medium',
  estimatedTime = 30,
  impact = '',
  sourceData = {},
  buttonStyle = 'secondary',
  onSuccess
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClick = async (e) => {
    e.stopPropagation();
    if (!title) return;
    setLoading(true);
    setError(null);
    try {
      const item = {
        title,
        description,
        category,
        priority,
        estimatedTime,
        impact,
        sourceData,
        dueDate: new Date().toISOString(),
        type: 'task'
      };
      await addToPriorityQueue(item);
      onSuccess && onSuccess(item);
    } catch (err) {
      console.error('Add to queue failed:', err);
      setError('Failed to add to queue');
    }
    setLoading(false);
  };

  const variant =
    buttonStyle === 'primary'
      ? 'default'
      : buttonStyle === 'minimal'
      ? 'ghost'
      : 'outline';

  return (
    <div>
      <Button
        variant={variant}
        size="sm"
        type="button"
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? (
          <span className="animate-pulse">Adding...</span>
        ) : (
          <>
            <span>+ Queue</span>
          </>
        )}
      </Button>
      {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
    </div>
  );
}

export default AddToQueueButton;
